@if (visible()) {
  <mat-progress-bar color="primary" class="z-[99] !fixed top-0 w-full" mode="indeterminate" />
}
